import { MessageCircle, FileText } from "lucide-react";
import { brand } from "../data/siteContent";

export default function FloatingButtons() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const whatsappText = encodeURIComponent(
    "Γεια σας, θα ήθελα πληροφορίες για κουφώματα αλουμινίου."
  );

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      <a
        href={`https://wa.me/${brand.whatsapp}?text=${whatsappText}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
        title={`WhatsApp — ${brand.phones[1].display}`}
        className="w-12 h-12 md:w-14 md:h-14 bg-[#25D366] hover:bg-[#1ebe57] text-white flex items-center justify-center shadow-lg shadow-black/20 transition-colors"
      >
        <MessageCircle size={22} strokeWidth={2} />
      </a>

      <button
        onClick={() => scrollTo("contact")}
        data-testid="floating-quote"
        className="group flex items-center gap-3 bg-brand-red hover:bg-brand-redHover text-white pl-4 pr-5 py-3 md:py-4 shadow-lg shadow-black/20 transition-colors"
      >
        <FileText size={18} strokeWidth={1.8} />
        <span className="text-[11px] md:text-xs font-semibold tracking-widest uppercase">
          Ζητήστε Προσφορά
        </span>
      </button>
    </div>
  );
}
